import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateCompanyChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateCompanyChiftInvoicingPaymentSyncController.php
* @route '/api/company/{company}/partners/chift-invoicing/payment-sync'
*/
const UpdateCompanyChiftInvoicingPaymentSyncController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCompanyChiftInvoicingPaymentSyncController.url(args, options),
    method: 'put',
})

UpdateCompanyChiftInvoicingPaymentSyncController.definition = {
    methods: ["put"],
    url: '/api/company/{company}/partners/chift-invoicing/payment-sync',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateCompanyChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateCompanyChiftInvoicingPaymentSyncController.php
* @route '/api/company/{company}/partners/chift-invoicing/payment-sync'
*/
UpdateCompanyChiftInvoicingPaymentSyncController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return UpdateCompanyChiftInvoicingPaymentSyncController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateCompanyChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateCompanyChiftInvoicingPaymentSyncController.php
* @route '/api/company/{company}/partners/chift-invoicing/payment-sync'
*/
UpdateCompanyChiftInvoicingPaymentSyncController.put = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCompanyChiftInvoicingPaymentSyncController.url(args, options),
    method: 'put',
})

export default UpdateCompanyChiftInvoicingPaymentSyncController